// extracted by mini-css-extract-plugin
export default {"productCardContainer":"style_productcard_productCardContainer__BPRfA","img":"style_productcard_img__rB1fn","title":"style_productcard_title__3cCnt"};